import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import Router from "./router";
import { useDispatch, useSelector } from "react-redux";
import { getAllFacilitiesModal, getAllFacilityTypes } from "./services";
import { getAllNoteTypes } from "./services/note";
import { getAllPatientsModal } from "./services/patient";
import { getProfile } from "./services/profile";
import { getAllStaff } from "./services/staff";
import { decrypt, getCookie } from "./utils";
import { io } from "socket.io-client";
import { environment, socketURL } from "./http";
import { getNotificationsCount, getNotifications } from "./services/notification";
import { setTimeZone } from "./store/reducers/profile";
import mixpanel from "mixpanel-browser";
import InactivityLogoutTimer from "./utils/InactivityLogoutTimer";
import { initSplitAndDispatch } from "./utils/split";
import {
  MIXPANEL_TOKEN_PRODUCTION_ENC,
  MIXPANEL_TOKEN_STAGING_ENC,
} from "./constants";
import { getSubscriptionCard } from "./services/subscription";

const socket = io(socketURL);

function App() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const { profile } = useSelector((state) => {
    return state?.profile;
  });

  useEffect(() => {
    if (profile?.user?.id && window.pendo) {
      const pendoConfig = {
        visitor: {
          id: profile?.user?.id,
          email: profile?.user?.email,
          full_name: profile?.user?.name,
          role: profile?.user?.role || "",
          type: profile?.user?.type || "main admin",
          position: profile?.user?.position || "",
        },
        account: {
          id: profile?.business?.id,
          name: profile?.business?.companyName,
          subscription_plan: profile?.subscription?.packageId?.name,
          subscription_expired: profile?.subscriptionExpired || false,
        },
      };

      if (window.pendo.isReady && window.pendo.isReady()) {
        window.pendo.updateOptions(pendoConfig);
      } else {
        window.pendo.initialize(pendoConfig);
      }
    }
  }, [profile]);
  useEffect(() => {
    if (profile?.user?.id) {
      initSplitAndDispatch(profile?.user?.id, dispatch);
      socket.emit("join", profile.user.id);
    }
  }, [profile?.user?.id]);


  useEffect(() => {
    const rejoin = () => {
      if (profile?.user?.id) socket.emit("join", profile.user.id);
    };
    socket.on("connect", rejoin);
    return () => socket.off("connect", rejoin);
  }, [profile?.user?.id]);

  useEffect(() => {
    const handleOcrReady = (data) => {
      console.log("[App] dispatching window event", data);
      window.dispatchEvent(new CustomEvent("medication-ocr-ready", { detail: data }));
      // Best-effort only: multiple submitted images can exceed sessionStorage's
      // quota, so this fallback (for when the modal isn't mounted yet) is
      // allowed to silently fail — the live dispatch above is what matters.
      try {
        sessionStorage.setItem("pendingOcrResult", JSON.stringify(data));
      } catch {}
    };
    socket.on("medication-ocr-ready", handleOcrReady);
    return () => socket.off("medication-ocr-ready", handleOcrReady);
  }, []);

  useEffect(() => {
    const mixpanelToken =
      environment === "production"
        ? decrypt(MIXPANEL_TOKEN_PRODUCTION_ENC)
        : decrypt(MIXPANEL_TOKEN_STAGING_ENC);

    mixpanel.init(mixpanelToken, {
      debug: true,
      track_pageview: true,
      persistence: "localStorage",
    });
    getDetails();
    getCount();
  }, []);

  useEffect(() => {
    // Any org action (e.g. a staff time-off request, a new note) emits this
    // event with the org owner's id. Refetch the bell for members of that org
    // so notifications appear in real time instead of only on refresh. The
    // payload is { adminId }; older callers may emit the bare id.
    const onNotification = (data) => {
      const myAdminId = profile?.user?.admin || profile?.user?.id;
      const incoming = data?.adminId ?? data;
      if (myAdminId && incoming && String(incoming) === String(myAdminId)) {
        getNotifications({ page: 1, limit: 10 });
      }
    };
    socket.on("get-notification-count", onNotification);
    return () => socket.off("get-notification-count", onNotification);
  }, [profile]);

  const getCount = async () => {
    // await getNotificationsCount();
  };

  const getDetails = async () => {
    const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    dispatch(setTimeZone(currentTimezone));

    const token = getCookie("token");
    if (token) {
      const response = await getProfile(true, token, currentTimezone);
      if (response) {
        // getAllStaff("all");
        getAllStaff(1, true, true);
        getAllNoteTypes();
        getAllFacilityTypes();
        getAllFacilitiesModal("all");
        getAllPatientsModal();
        // getSubscriptionCard();
        // getAllSkypointProvider("all");
        setLoading(false);
      } else setLoading(false);
    } else {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      {loading ? (
        <div
          style={{
            height: "100vh",
            padding: "60px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src="/assets/images/logo2.png"
            alt="logo"
            style={{ width: "20%", objectFit: "contain" }}
          />
          {/* <TableLoader /> */}
        </div>
      ) : (
        <BrowserRouter>
          <InactivityLogoutTimer />
          <Router />
        </BrowserRouter>
      )}
    </div>
  );
}

export default App;
